// Content for the "Life at Origo" page. Optional photos: put images in /public/life/ using the file names below.
export const LIFE_PERKS = [
  { icon: 'heart', title: 'People first', desc: 'We look out for each other, at work and beyond it.' },
  { icon: 'team', title: 'One team spirit', desc: 'Designers, engineers and marketers celebrate together.' },
  { icon: 'bulb', title: 'Always learning', desc: 'Workshops, talks and time to grow new skills.' },
  { icon: 'clock', title: 'Healthy balance', desc: 'Flexible hours and real time off to recharge.' },
];

export const LIFE_EVENTS = [
  {
    slug: 'annual-picnic', icon: 'tent', tag: 'Yearly tradition', title: 'The Annual Picnic', photo: '/life/annual-picnic.jpg',
    text: 'Once a year the whole company swaps laptops for a full day outdoors: travelling together, playing games, sharing food and making memories that last long after the day ends.',
    points: ['Whole team and families invited', 'Games, music and prizes', 'Group lunch and BBQ', 'A new location every year'],
  },
  {
    slug: 'team-outings', icon: 'ball', tag: 'Day trips', title: 'Team Picnics & Outings', photo: '/life/team-outings.jpg',
    text: 'Between the big events we plan smaller team picnics, hikes and day trips, a relaxed way to reset after a launch and get to know colleagues from other departments.',
    points: ['Post-launch celebration trips', 'Cross-team mixers', 'Hiking and park days', 'Transport arranged for everyone'],
  },
  {
    slug: 'birthday-parties', icon: 'cake', tag: 'Every month', title: 'Birthday Celebrations', photo: '/life/birthdays.jpg',
    text: 'No birthday goes unnoticed. We cut a cake, share a few kind words and give the birthday star a card signed by the whole team, a small ritual that means a lot.',
    points: ['Monthly cake cutting', 'Cards and surprise gifts', 'Decorated workspace', 'Photos for the team wall'],
  },
  {
    slug: 'ramazan-iftar', icon: 'moon', tag: 'Ramazan special', title: 'Ramazan Iftar Buffet', photo: '/life/iftar-buffet.jpg',
    text: 'During Ramazan the team breaks fast together at an iftar buffet with dates, samosas, fruit chaat and more, sharing the evening in the spirit of togetherness and gratitude.',
    points: ['Company-hosted iftar buffet', 'Shorter working hours in Ramazan', 'Dinner boxes for late shifts', 'Charity and giving drives'],
  },
  {
    slug: 'eid-celebrations', icon: 'star', tag: 'Festive season', title: 'Eid & Festive Celebrations', photo: '/life/eid.jpg',
    text: 'We welcome Eid and other festivals with decorations, sweets, greetings and a team lunch before the holidays begin, so everyone leaves with a smile.',
    points: ['Eid gatherings and sweets', 'Festival decorations', 'Eid bonus and gifts', 'Team lunch before the break'],
  },
  {
    slug: 'sports-days', icon: 'trophy', tag: 'Friendly rivalry', title: 'Sports & Game Days', photo: '/life/sports-day.jpg',
    text: 'Cricket matches, table tennis, gaming tournaments and treasure hunts: friendly competition that brings out everyone\'s energy (and a bit of trash talk).',
    points: ['Office cricket tournament', 'Table tennis and board games', 'Gaming nights', 'Trophies for the winners'],
  },
  {
    slug: 'learning-days', icon: 'bulb', tag: 'Grow together', title: 'Workshops & Learning Days', photo: '/life/learning.jpg',
    text: 'Regular lunch-and-learns, internal tech talks and guest sessions help us share knowledge, try new tools and grow our skills as a team.',
    points: ['Monthly tech talks', 'Course and certification support', 'Hackathon days', 'Mentorship for new joiners'],
  },
  {
    slug: 'office-life', icon: 'utensils', tag: 'Everyday moments', title: 'Friday Lunches & Office Life', photo: '/life/office-life.jpg',
    text: 'The little things count: Friday team lunches, chai breaks, a stocked pantry and an office designed to be a comfortable place to do great work.',
    points: ['Friday team lunch', 'Chai and snack corner', 'Comfortable workspace', 'Celebrating work anniversaries'],
  },
];
